import { useDispatch } from 'react-redux';
import { Trans } from 'services/i18n';

import { BUTTON_SIZES, BUTTON_VARIANTS, Button } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { DataFeedsModalStateType, useModalContext } from 'utils/contexts/modal';

import { clearDataFeedsError, deleteDataFeedsRequest } from '../../actions';
import { DataFeed } from '../../types';
import { useTranslations } from '../../hooks/useTranslations';

export const ids = {
  modal: 'df-delete-modal',
  btnDelete: 'df-delete-modal-submit-btn',
};

export const testIds = {
  btnDelete: ids.btnDelete,
};

export const ConfirmDeleteModal = () => {
  const { t } = useTranslations();
  const dispatch = useDispatch();
  const { modalState, hideModal } = useModalContext<DataFeedsModalStateType>();
  const dataFeed = modalState?.dataFeed as DataFeed;
  const primaryAction = () => dispatch(deleteDataFeedsRequest(dataFeed.id, hideModal));

  return (
    <Modal
      id={ids.modal}
      isModalOpen={true}
      onClose={() => {
        hideModal();
        dispatch(clearDataFeedsError());
      }}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>{t('header.deleteDataFeed')}</ModalHeader>
      <ModalBody>
        <Trans
          t={t}
          i18nKey="caption.confirmDelete"
          components={{
            ctaStrong: <strong />,
          }}
          values={{ name: modalState?.dataFeed?.name }}
        >
          Are you sure you want to delete <strong>{modalState?.dataFeed?.name}</strong>? This cannot
          be undone.
        </Trans>
      </ModalBody>
      <ModalFooter cancelLabel={t('button.cancel')}>
        <Button
          data-test={testIds.btnDelete}
          id={ids.btnDelete}
          onClick={primaryAction}
          variant={BUTTON_VARIANTS.DESTRUCTIVE}
          size={BUTTON_SIZES.LARGE}
        >
          {t('button.delete')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmDeleteModal;
